import React from 'react';
import { extractAccuracyTrustStrip, trustStripToneForBand } from '../../../utils/accuracyModeMeta';
import styles from '../css/index.module.css';

const TONE_CLASS = {
    success: styles.aiWardenTrustStripSuccess,
    warning: styles.aiWardenTrustStripWarning,
    danger: styles.aiWardenTrustStripDanger,
    neutral: styles.aiWardenTrustStripNeutral,
};

const AccuracyTrustStrip = ({ retrievalDebug, topLevelConfidence }) => {
    const strip = extractAccuracyTrustStrip({
        retrievalDebug,
        topLevelConfidence,
    });
    if (!strip?.items?.length) return null;

    if (strip.pipelineActive === false) {
        const item = strip.items[0];
        return (
            <div
                className={styles.aiWardenAccuracyTrustInactive}
                role="status"
                aria-label="Accuracy mode inactive on server">
                <strong>
                    {item?.label}: {item?.value}
                </strong>
                {item?.detail ? <div>{item.detail}</div> : null}
            </div>
        );
    }

    return (
        <div
            className={styles.aiWardenAccuracyTrustGrid}
            role="status"
            aria-label="Accuracy mode evidence summary">
            {strip.items.map(item => {
                const tone = item.band ? trustStripToneForBand(item.band) : 'neutral';
                return (
                    <div
                        key={item.key}
                        className={`${styles.aiWardenAccuracyTrustCell} ${TONE_CLASS[tone] || TONE_CLASS.neutral}`}>
                        <span className={styles.aiWardenAccuracyTrustCellLabel}>{item.label}</span>
                        <span className={styles.aiWardenAccuracyTrustCellValue}>{item.value}</span>
                        {item.detail ? (
                            <span className={styles.aiWardenAccuracyTrustCellDetail}>{item.detail}</span>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
};

export default AccuracyTrustStrip;
